import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieConsent } from '@models/enums/components/Cookies/CookieConsent.enum';
import { AnalyticsService } from '@services/analytics.service';
import { TranslationService } from '@services/translation.service';

@Component({
  selector: 'app-cookies',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cookies.component.html',
  styleUrl: './cookies.component.css',
})
export class CookiesComponent implements OnInit {
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly analyticsService: AnalyticsService =
    inject(AnalyticsService);

  public readonly translation: TranslationService = inject(TranslationService);

  protected readonly team: string | null =
    this.route.snapshot.paramMap.get('team');

  public selectedConsent: CookieConsent = CookieConsent.Necessary;
  public CookieConsent = CookieConsent;

  public displayCookiesSettings: boolean = false;

  private get storageKey(): string {
    return `cookiesAccepted_${this.team}`;
  }

  public get isHidden(): boolean {
    return this.analyticsService.hideCookiesBanner;
  }

  ngOnInit(): void {
    if (this.isInIframe()) {
      this.analyticsService.hideCookiesBanner = true;
      return;
    }

    const consent = localStorage.getItem(this.storageKey);

    if (consent === 'true') {
      this.selectedConsent = CookieConsent.Analytics;
      this.analyticsService.init();
    } else if (consent === 'false') {
      this.selectedConsent = CookieConsent.Necessary;
    }

    this.analyticsService.hideCookiesBanner = consent !== null;
  }

  private isInIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch {
      return true;
    }
  }

  public onAnalyticsToggle(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.selectedConsent = checked
      ? CookieConsent.Analytics
      : CookieConsent.Necessary;
  }

  public acceptCookies() {
    localStorage.setItem(this.storageKey, 'true');
    this.analyticsService.hideCookiesBanner = true;
    this.analyticsService.init();
  }

  public customizeCookies() {
    this.displayCookiesSettings = true;
  }

  public rejectCookies() {
    localStorage.setItem(this.storageKey, 'false');
    this.analyticsService.hideCookiesBanner = true;
  }

  public savePreferences() {
    const isAnalytics = this.selectedConsent === CookieConsent.Analytics;

    localStorage.setItem(this.storageKey, isAnalytics ? 'true' : 'false');
    this.analyticsService.hideCookiesBanner = true;

    if (isAnalytics) {
      this.analyticsService.init();
    }
  }
}
